<tec-detail-layout back backAction="emit" (backEvent)="onBack($event)">
	<tec-empty-state
		[title]="titleKey() | translate"
		[description]="descriptionKey() | translate"
		[size]="'default'"
		[labelAction]="showRetry() ? (retryLabelKey() | translate) : undefined"
		[type]="kind() === 'not_found' ? 'empty' : 'error'"
		(clickEvent)="onRetry()"
	/>
</tec-detail-layout>
